<form [formGroup]="addCatalogForm" (ngSubmit)="onSubmit()">
    <div class="dialog-header"> 
        <h2 class="dialog-title">New Catalog Creation</h2>   
        <button class="cancel-button" mat-button type="button" [disabled]="isSubmitting()" (click)="onCancel()">Cancel</button>
    </div>
    <div class="dialog-body">
        <mat-dialog-content class="dialog-form">
            <div class="catalog-name-container">
                <div class="catalog-name-header">
                    <p class="catalog-header">Catalog Name</p>
                </div>
                <div class="catalog-name-fields">
                    <div class="toggle-container">
                        <mat-slide-toggle formControlName="appendTenantIdToCatalogName"></mat-slide-toggle>
                        <mat-label> Append Tenant ID to Catalog Name </mat-label>
                    </div>
                    <mat-form-field>
                        <mat-label>Catalog Name</mat-label>
                        <input class="input" matInput formControlName="catalogName">
                        @if (addCatalogForm.get('catalogName')?.errors?.['required']) {
                            <mat-error>Catalog name is required.</mat-error>
                        }
                        @if (addCatalogForm.get('catalogName')?.errors?.['pattern']) {
                            <mat-error>Catalog name must be up to 255 characters, and cannot contain spaces, periods, or forward slashes.</mat-error>
                        }
                    </mat-form-field>
                    <mat-card>
                        @if (getAppendTenantIdToCatalogName()) {
                            <p class="catalog-name-preview"> Preview: {{getCatalogName()}}_{{this.tenantContextService.tenant()?.tenantId}} </p>
                        } @else {
                            <p class="catalog-name-preview"> Preview: {{getCatalogName()}} </p>
                        }
                    </mat-card>
                </div>
            </div>
            <mat-form-field>
                <mat-label>Data Lake</mat-label>
                <mat-select formControlName="dataLake">
                    @if (isDataLakesLoading()) {
                        <mat-option disabled>
                            <div matSuffix class="loading-option">
                                <div class="loading-spinner">
                                    <app-loading-spinner [strokeWidth]="5"></app-loading-spinner>
                                </div>
                                <p>Loading available data lakes...</p>
                            </div>
                        </mat-option>
                    } @else if (dataLakesErrorMessage() === "" && dataLakes().length > 0){   
                        @for (dataLake of dataLakes(); track dataLake.dataStoreId) {
                            <mat-option [value]="dataLake.dataStoreId">{{dataLake.storeName}}</mat-option>
                        }
                    } @else if (dataLakes().length === 0){   
                        <mat-option disabled>
                            <div>No available data lakes. Please create a new data lake.</div>
                        </mat-option>
                    } @else {
                        <mat-option disabled>
                            <div class="error-message">{{dataLakesErrorMessage()}}</div>
                        </mat-option>
                    }
                </mat-select>
                @if (addCatalogForm.get('dataLake')?.errors?.['required']) {
                    <mat-error>Data lake is required.</mat-error>
                }
            </mat-form-field>
            <mat-form-field>
                <mat-label>Landing Zone</mat-label>
                <mat-select formControlName="landingZone">
                    @if (isLandingZonesLoading()) {
                        <mat-option disabled>
                            <div matSuffix class="loading-option">
                                <div class="loading-spinner">
                                    <app-loading-spinner [strokeWidth]="5"></app-loading-spinner>
                                </div>
                                <p>Loading available landing zones...</p>
                            </div>
                        </mat-option>
                    } @else if (landingZonesErrorMessage() === "" && landingZones().length > 0) {            
                        @for (landingZone of landingZones(); track landingZone.dataStoreId) {
                            <mat-option [value]="landingZone.dataStoreId">{{landingZone.storeName}}</mat-option>
                        }
                    } @else if (landingZones().length === 0){   
                        <mat-option disabled>
                            <div>No available landing zones Please create a new landing zone.</div>
                        </mat-option>
                    } @else {
                        <mat-option disabled>
                            <div class="error-message">{{landingZonesErrorMessage()}}</div>
                        </mat-option>
                    }
                </mat-select>
                @if (addCatalogForm.get('landingZone')?.errors?.['required']) {
                    <mat-error>Landing zone is required.</mat-error>
                }
            </mat-form-field>
            <div class="checkbox">
                <mat-label class="checkbox-title">Workspaces*</mat-label>
                <ul class="checkbox-list">
                    @for (workspace of activeWorkspaces; track $index) {
                        <li>
                            <mat-checkbox [formControl]="getWorkspaceCheckboxControl($index)">
                                {{workspace.workspaceName}}
                            </mat-checkbox>
                        </li>
                    }
                </ul>
                @if (addCatalogForm.get('workspaces')?.hasError('required') && addCatalogForm.get('workspaces')?.touched) {
                    <mat-error>At least one workspace must be selected.</mat-error>
                }
            </div>
            @if (submissionErrorMessage()) {
                <div class="error-message">{{submissionErrorMessage()}}</div>
            }
        </mat-dialog-content>
    </div>
    <mat-dialog-actions class="dialog-footer">
        <button class="submit-button" mat-flat-button 
            color="primary"
            type="submit" 
            [disabled]="!addCatalogForm.valid || isSubmitting()"> 
            @if (!isSubmitting()) {
                Create Catalog
            } @else {
                <div class="loading-spinner">
                    <app-loading-spinner [strokeWidth]="5"></app-loading-spinner>
                </div>
            }   
        </button>
    </mat-dialog-actions>
</form>